export default __webpack_public_path__ + "static/media/fondo-neutral.c04f1cd9.png";